import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import {useForm} from "react-hook-form";
import AdditionalHoursForm from "../../../Components/Forms/Pages/HR/AdditionalHours/AdditionalHoursForm";
import strings from "../../../localization";
import { editAddtionalHours } from "../../../Services/HR/AdditionalHoursService";
import { getOrganisationUserContractList } from "../../../Services/HR/OrganisationUserContractService";
import DrawerContext from "../../../Context/DrawerContext";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'status': {required: true},
    'hours': {required: true},
    'startDate': {required: true},
    'endDate': {required: true},
    'organisationUserContract': {required: true}
}

const EditAdditionalHours = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? {...props.data[0], status: {id: props.data[0].status}} : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [organisationUserContracts, setOrganisationUserContracts] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.additionalHours.editAdditionalHours.pageTitle);
    });

    useEffect(() => {
        fetch();
    }, [])

    const fetch = () => {
        getOrganisationUserContractList().then(response => {
            if (!response || !response.ok){
                return;
            }
            setOrganisationUserContracts(response.data.result);
        })
    }

    const onSubmit = (data) => {
        setShowLoader(true);

        editAddtionalHours(data).then(response => {
            setShowLoader(false);

            if(!response){
                showMessage(strings.commonMessages.errorEditing, 'error');
                return;
            }
            if (!response.ok) {
                showMessage(response.response.data.message, 'error', 5000);
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <AdditionalHoursForm
                formRules={formRules}
                values={getValues()} setValue={setValue} onChangeUserContractFilter={fetch}
                data={data} errors={errors} form={form} control={control}
                organisationUserContracts={organisationUserContracts}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}

export default EditAdditionalHours;